import { useEffect, useMemo, useState } from 'react';
import { apiClient } from '../config/api';

export const useQualityInsights = (projectId, { since, allowLong } = {}) => {
  const [state, setState] = useState(() => ({
    loading: false,
    error: null,
    heatmap: null,
    trend: null,
    mttr: null,
    metadata: null,
    batches: null,
  }));

  useEffect(() => {
    if (!projectId) {
      return;
    }

    let active = true;
    setState((prev) => ({
      ...prev,
      loading: true,
      error: null,
    }));

    const controller = new AbortController();

    const load = async () => {
      try {
        const [heatmapRes, trendRes, mttrRes, metadataRes, batchRes] = await Promise.all([
          apiClient.getQualityHeatmap(projectId, { since, allowLong }),
          apiClient.getQualityTrend(projectId, { since, allowLong }),
          apiClient.getQualityMttr(projectId),
          apiClient.getQualityMetadata(projectId),
          apiClient.getQualityBatches(projectId, { limit: 10 }),
        ]);

        if (!active) return;

        setState({
          loading: false,
          error: null,
          heatmap: heatmapRes,
          trend: trendRes,
          mttr: mttrRes,
          metadata: metadataRes,
          batches: batchRes,
        });
      } catch (err) {
        if (!active) return;
        setState((prev) => ({
          ...prev,
          loading: false,
          error: err.message || 'Unable to load quality insights.',
        }));
      }
    };

    load();

    return () => {
      active = false;
      controller.abort();
    };
  }, [projectId, since, allowLong]);

  const memoized = useMemo(() => state, [state]);
  return memoized;
};

export default useQualityInsights;

